module.exports = __webpack_public_path__ + "media/images/client-36-2cc5748aa7700c2c6033d8cecd7968f8.png";